import {
  ContractType,
  PendingContractResponse,
  RemittedContractResponse
} from '@dav-model/api/response/pending-contract.response.model';
import { ContractFilterType, ContractFilterGroupType } from '@dav-model/remit-filter.model';
import { Action } from '@ngrx/store';

/**
 * When User initially visits our page, UI will
 * get all images and css
 */

export const GET_PENDING_CONTRACTS = '[Remit] GET PENDING_CONTRACTS';
export const GET_PENDING_CONTRACTS_SUCCESS = '[Remit] GET PENDING_CONTRACTS SUCCESS';
export const FILTER_PENDING_GRID = '[Remit] FILTER PENDING GRID';
export const ADD_TO_PENDING_REMIT = '[Remit] ADD PENDING TO REMIT';
export const DELETE_FROM_PENDING_REMIT = '[Remit] DELETE FROM PENDING TO REMIT';
export const SUBMIT_ALL_PENDING_REMIT = '[Remit] SUBMIT ALL PENDING REMIT';
export const SUBMIT_ALL_PENDING_REMIT_SUCCESS = '[Remit] SUBMIT ALL PENDING REMIT SUCCESS';
export const DECLINE_PENDING_CONTRACT = '[Remit] DECLINE PENDING CONTRACT';
export const REINSTATE_PENDING_CONTRACT = '[Remit] REINSTATE PENDING CONTRACT';
export const ADD_ALL_TO_PENDING_REMIT = '[Remit] ADD ALL FROM PENDING TO REMIT';
export const REMOVE_ALL_FROM_PENDING_REMIT_ONLY = '[Remit] REMOVE ALL FROM PENDING TO REMIT (exclude Declined)';
export const REMOVE_ALL_FROM_DECLINED_REMIT_ONLY = '[Remit] REMOVE ALL FROM PENDING TO REMIT (excluded remit pending)';
export const REMIT_FAILURE = '[remit] REMIT FAILURE';

export const GET_REMITTED_CONTRACTS = '[Remit] GET REMITTED CONTRACTS';
export const GET_REMITTED_CONTRACTS_SUCCESS = '[Remit] GET INITIAL LAYOUT SUCCESS';
export const FILTER_REMITTED_GRID = '[Remit] FILTER REMITTED GRID';

export class GetPendingContractsAction implements Action {
  readonly type = GET_PENDING_CONTRACTS;
}

export class GetPendingContractsSuccessAction implements Action {
  readonly type = GET_PENDING_CONTRACTS_SUCCESS;

  constructor(public payload: { contracts: PendingContractResponse, filters: ContractFilterType[] }) {
  }
}

export class FilterPendingGridAction implements Action {
  readonly type = FILTER_PENDING_GRID;

  constructor(public payload: ContractFilterType[]) {
  }
}

export class AddToPendingRemitAction implements Action {
  readonly type = ADD_TO_PENDING_REMIT;

  constructor(public payload: ContractType) {
  }
}

export class SubmitAllPendingRemitAction implements Action {
  readonly type = SUBMIT_ALL_PENDING_REMIT;
}

export class SubmitAllPendingRemitSuccessAction implements Action {
  readonly type = SUBMIT_ALL_PENDING_REMIT_SUCCESS;

  constructor(public payload: {
    submittedRemittedRequest: ContractType[],
    contracts: PendingContractResponse, filters: ContractFilterType[]
  }) {
  }
}

export class DeleteFromPendingRemitAction implements Action {
  readonly type = DELETE_FROM_PENDING_REMIT;

  constructor(public payload: string) {
  }
}

export class DeclinePendingContractAction implements Action {
  readonly type = DECLINE_PENDING_CONTRACT;

  constructor(public payload: ContractType) {
  }
}

export class ReinstatePendingContractAction implements Action {
  readonly type = REINSTATE_PENDING_CONTRACT;

  constructor(public payload: ContractType) {
  }
}

export class AddAllFromPendingRemitAction implements Action {
  readonly type = ADD_ALL_TO_PENDING_REMIT;

  constructor(public payload?: ContractType[]) {
  }
}

export class RemoveAllFromPendingRemitOnlyAction implements Action {
  readonly type = REMOVE_ALL_FROM_PENDING_REMIT_ONLY;
}

export class RemoveAllFromDeclinedRemitOnlyAction implements Action {
  readonly type = REMOVE_ALL_FROM_DECLINED_REMIT_ONLY;
}

// REMITTED CONTRACT ACTIONS ////////////////////////////////////////////

export class GetRemittedContractsAction implements Action {
  readonly type = GET_REMITTED_CONTRACTS;
}

export class GetRemittedContractsSuccessAction implements Action {
  readonly type = GET_REMITTED_CONTRACTS_SUCCESS;

  constructor(public payload: { contracts: RemittedContractResponse, filters: ContractFilterGroupType[] }) {
  }
}

export class FilterRemittedGridAction implements Action {
  readonly type = FILTER_REMITTED_GRID;

  constructor(public payload: ContractFilterGroupType[]) {
  }
}


/////////////////////////////////////////////////////////////////////////

export class RemitFailureAction implements Action {
  readonly type = REMIT_FAILURE;
}

export type All =
  GetPendingContractsAction
  | GetPendingContractsSuccessAction
  | FilterPendingGridAction
  | RemitFailureAction
  | AddToPendingRemitAction
  | DeleteFromPendingRemitAction
  | DeclinePendingContractAction
  | ReinstatePendingContractAction
  | AddAllFromPendingRemitAction
  | RemoveAllFromDeclinedRemitOnlyAction
  | RemoveAllFromPendingRemitOnlyAction
  | SubmitAllPendingRemitAction
  | SubmitAllPendingRemitSuccessAction
  | GetRemittedContractsSuccessAction
  | FilterRemittedGridAction;
